module.exports = __webpack_public_path__ + "826673f1d6736404c47db8d58b30180a.pdf";